import * as React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard } from "@fortawesome/pro-light-svg-icons/faCreditCard";
import { faHandPointer } from "@fortawesome/pro-light-svg-icons/faHandPointer";
var VxPaymentHint = function () {
  var _a;
  if (!((_a = window.layoutSettings.content.display) === null || _a === void 0 ? void 0 : _a.payhint)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "payment-hint"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "lg",
    icon: faCreditCard
  }), " ", "Jetzt Paypal, Kreditkarte oder Lastschrift f\u00FCr echte Livechats und Videos nutzen und ", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.visit-x.net/?w=".concat(window.paramW, "&ws=").concat(window.paramWS, ".basbk&pc=CW100PCT&vxpAutoFlow=Signup"),
    target: "_blank"
  }, "100% auf die erste Aufladung erhalten"), " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "lg",
    icon: faHandPointer,
    style: {
      transform: "rotate(-45deg) translate(-5px,3px)"
    }
  }));
};
export default VxPaymentHint;